import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api';
import SolutionsCarouselSlideMobile from '~/components/sections/sliderSection/SolutionsCarouselSlideMobile.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

interface Props {
  slides?: any[];
}
interface Emits {
  (e: 'slide-change', data: number): void;
  (e: 'init', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsCarouselSliderMobile',
  props: {
    slides: { default: () => [] }
  },
  emits: ["slide-change", "init"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'slide-change', data: number): void;
  (e: 'init', data: any): void;
}), expose: any, slots: any, attrs: any }) {





const swiper = ref();
const swiperOptions = {
  observer: true,
  slidesPerView: 1,
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
  on: {
    activeIndexChange: () => {
      emit('slide-change', swiper.value.$swiper.activeIndex);
    },
  },
};

return { __sfc: true,emit, swiper, swiperOptions, SolutionsCarouselSlideMobile, Swiper, SwiperSlide }
}

})